export default __webpack_public_path__ + "static/media/RecentUploads.b0cfe073.svg";